var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10V11C2 11 2 11.43 2 12V12.99C2 13.99 2 15 2 15C2 15.55 2.45 16 3 16H6V11H10V16H13C13.55 16 14 15.55 14 15V10L8 4L2 10ZM15.71 7.29L14 5.59V2C14 1.45 13.55 1 13 1C12.45 1 12 1.45 12 2V3.59L8.71 0.29C8.53 0.11 8.28 0 8 0C7.72 0 7.47 0.11 7.29 0.29L0.29 7.29C0.11 7.47 0 7.72 0 8C0 8.55 0.45 9 1 9C1.28 9 1.53 8.89 1.71 8.71L8 2.41L14.29 8.7C14.47 8.89 14.72 9 15 9C15.55 9 16 8.55 16 8C16 7.72 15.89 7.47 15.71 7.29Z",
    fill: "#52BD94"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeShape);
export default __webpack_public_path__ + "static/media/homeShape.e064dfb0be7fdb9b43ebbc3d7e567e63.svg";
export { ForwardRef as ReactComponent };